import { isPending, Result } from "@/common/common";
import { DestinationFolder } from "@/archive/archiveDomain";
import { ArchiveDocumentType } from "@/archive/commonArchiveDomain";
import { FileUploadConfig } from "@/fileUpload/fileUploadDomain";

export type ZipImportResult = { files: number; folders: number };

const zipImportErrorMessages: Record<string, string> = {
  INVALID_FOLDER:
    "The destination folder does not exist, belongs to another company, or is in the trash.",
  INVALID_ZIP: "The file is not a valid zip file.",
  NO_FILES: "The zip has no files.",
  TOO_LARGE: "The zip has too many files, or unpacks to too much data.",
};

export const zipImportErrorMessage = (errors: unknown): string =>
  (Array.isArray(errors) &&
    errors.map((it) => zipImportErrorMessages[String(it)]).find((it) => it !== undefined)) ||
  "The import failed.";

export const zipUploadConfig: FileUploadConfig = {
  supportedFileTypes: [{ extensions: ["zip"], magicBytes: [[0x50, 0x4b, 0x03, 0x04]] }],
  maxFileSize: 100 * 1024 * 1024,
};

export const defaultZipImportFolder = (
  folders: DestinationFolder[],
): DestinationFolder | undefined =>
  folders.find((it) => it.type === ArchiveDocumentType.ADMIN_ARCHIVE_FOLDER);

export const canImportZip = (
  folder: DestinationFolder | undefined,
  file: File | undefined,
  result: Result<ZipImportResult, string> | undefined,
): boolean => folder !== undefined && file !== undefined && !isPending(result);
